var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoom = function SvgZoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#0B5CFF",
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 22.5a4.5 4.5 0 0 1 4.5-4.5h16a6.5 6.5 0 0 1 6.5 6.5v17a4.5 4.5 0 0 1-4.5 4.5h-16a6.5 6.5 0 0 1-6.5-6.5zm30 6.2 7.6-5.3a1.5 1.5 0 0 1 2.4 1.2v14.8a1.5 1.5 0 0 1-2.4 1.2L44 35.3z"
  })));
};
export default SvgZoom;